import Swiper from 'swiper';
import 'swiper/css';
import { Navigation, Pagination, Autoplay } from 'swiper/modules';

const helpers = window.BASE_HELPERS || {};
const { Mobile } = helpers;

const MODULE = document.querySelectorAll('[data-module="unidades_negocio"]');

class UnidadesNegocio {
    constructor() {
        this.components = MODULE;
        this.init();
    }

    init() {
        this.components.forEach(component => {
            if (Mobile.isMobile()) {
                const swiperComponent = component.querySelector('.swiper');
                if (swiperComponent) this.initSwiper(swiperComponent);
            }
        });
    }

    initSwiper(swiperComponent) {
        new Swiper(swiperComponent, {
            modules: [Pagination, Navigation, Autoplay],
            loop: true,
            slidesPerView: 'auto',
            navigation: {
                nextEl: swiperComponent.querySelector('.swiper-button-next'),
                prevEl: swiperComponent.querySelector('.swiper-button-prev'),
            },
            pagination: {
                el: swiperComponent.querySelector('.swiper-pagination'),
                clickable: true,
                type: 'bullets',
            },
        });
    }
}

(() => {
    if (MODULE) {
        new UnidadesNegocio();
    }
})();

export default UnidadesNegocio;
